import React from 'react';
export function ExpertSection() {
  return <section className="w-full bg-bg-dark py-24 px-4 border-t border-border-light/50 relative overflow-hidden" data-id="element-57">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-primary/10 rounded-full blur-[120px] pointer-events-none" data-id="element-58"></div>

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-59">
        <h2 className="text-4xl sm:text-6xl font-black text-text-main mb-6 tracking-tight" data-id="element-60">
          Deja de regalar tus noches a la planificación manual.
        </h2>

        <p className="text-text-sec text-xl sm:text-2xl leading-relaxed font-medium mb-12" data-id="element-61">
          Vuelve a disfrutar del campo. Nosotros hacemos el resto.
        </p>

        <div className="bg-bg-alt/80 backdrop-blur-sm border border-primary/30 rounded-3xl p-8 sm:p-12 shadow-[0_0_40px_rgba(22,163,74,0.15)]" data-id="element-62">
          <p className="text-text-sec font-bold uppercase tracking-widest mb-2" data-id="element-63">
            Precio Final
          </p>
          <p className="text-5xl sm:text-7xl font-black text-text-main mb-8 drop-shadow-lg" data-id="element-64">
            $19.90
          </p>

          <a href="https://docentes2.edulabs.online/cart/43285137490038:1" onClick={() => {
          const w = window as any;
          if (w.fbq) {
            w.fbq('track', 'AddToCart', {
              content_name: 'Combo Elite Fútbol',
              content_type: 'product',
              value: 19.9,
              currency: 'USD'
            });
          }
        }} className="btn-primary-pulse block w-full text-center bg-cta-green text-white font-black text-lg sm:text-2xl py-4 sm:py-6 rounded-2xl hover:bg-cta-green-hover transition-all shadow-[0_0_30px_rgba(16,185,129,0.3)] border border-white/20 mb-6" data-id="element-65">
            🚀 SÍ! QUIERO MI MEGAPACK DE FÚTBOL
          </a>

          <div className="flex flex-wrap items-center justify-center gap-4 text-text-sec text-sm font-medium" data-id="element-66">
            <span className="flex items-center gap-1.5" data-id="element-67">
              ⚡ Acceso Inmediato
            </span>
            <span className="hidden sm:inline" data-id="element-68">•</span>
            <span className="flex items-center gap-1.5" data-id="element-69">💳 Un solo Pago</span>
            <span className="hidden sm:inline" data-id="element-70">•</span>
            <span className="flex items-center gap-1.5" data-id="element-71">
              🛡️ Garantía 7 Días
            </span>
          </div>
        </div>
      </div>
    </section>;
}